import React, { useState, useEffect } from "react";
import ListGroup from "react-bootstrap/ListGroup";
import "./style.css";
import API from "../../utils/API";
import cogoToast from "@successtar/cogo-toast";
import { storage } from "../../config/Fire";

function CreateServiceRequest(props) {
  const [formData, setFormData] = useState({
    serviceReqType: "",
    serviceReqName: "",
    serviceReqEmail: "",
    serviceReqBody: "",
    url: "",
    declaration: ""
  });

  useEffect(() => {
    console.log(storage);
    console.log(props);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getBase64 = (file, callBack) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      callBack(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
      return error;
    };
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleServiceReqSubmit = (event) => {
    event.preventDefault();
    console.log("Submitting Service Request....");
    console.log("File; ");
    console.log(formData);
    console.log(formData.declaration);
    const serviceReqData = {
      type: formData.serviceReqType,
      name: formData.serviceReqName,
      requester: "Servicing",
      email: formData.serviceReqEmail,
      message: formData.serviceReqBody,
      fileData: formData.declaration
    };
    console.log(serviceReqData);
    API.saveServiceRequest(serviceReqData)
      .then((_res) => {
        console.log("Saved Service Request");
        alert("Service Request Saved!");
        cogoToast.success("Service Request Saved!");
      })
      .catch((err) => console.log(err));
  };

  const fileSelectedHandler = (event) => {
    event.preventDefault();
    console.log(event.target.files);

    if (event.target.files[0]) {
      getBase64(event.target.files[0], (res) => {
        console.log(res);
        setFormData((prev) => ({
          ...prev,
          declaration: res
        }));
      });
    }
  };

  return (
    <div className="card" style={{ backgroundColor: "rgba(0,0,0,0.75)", borderRadius: "5px" }}>
      <div className="card-header" style={{ textAlign: "center", backgroundColor: "transparent" }}>
        <h3 style={{ color: "whitesmoke" }}>Client Service Request</h3>
      </div>

      <div className="card-body" style={{ backgroundColor: "transparent" }}>
        <div className="row">
          <div className="col-10 offset-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
            <ListGroup className="list-group-flush">
              <form>
                <ListGroup.Item>
                  <label>Type of Request</label>
                  <br />
                  <select
                    style={{ width: "100%" }}
                    value={formData.serviceReqType}
                    onChange={handleInputChange}
                    name="serviceReqType"
                  >
                    <option value=""></option>
                    <option value="billing">Billing</option>
                    <option value="general">General</option>
                    <option value="req-mortgage-doc">Lienholder</option>
                    <option value="req-other">Other Request</option>
                    <option value="renewal-quote">New Quote</option>
                  </select>
                </ListGroup.Item>
                <ListGroup.Item>
                  <label>Customer Name</label>
                  <input
                    style={{ textAlign: "center" }}
                    value={formData.serviceReqName}
                    onChange={handleInputChange}
                    type="text"
                    name="serviceReqName"
                    className="form-control"
                  />
                </ListGroup.Item>
                <ListGroup.Item>
                  <label>Customer E-mail</label>
                  <input
                    style={{ textAlign: "center" }}
                    value={formData.serviceReqEmail}
                    onChange={handleInputChange}
                    type="email"
                    name="serviceReqEmail"
                    className="form-control"
                  />
                </ListGroup.Item>
                <ListGroup.Item>
                  <label>How may we help you?</label>
                  <textarea
                    value={formData.serviceReqBody}
                    onChange={handleInputChange}
                    name="serviceReqBody"
                    className="form-control"
                    rows="5"
                    cols="30"
                  />
                </ListGroup.Item>
                <ListGroup.Item>
                  <label>Please upload any related documentation (optional)</label>
                  <input name="fileData" type="file" onChange={fileSelectedHandler} />
                </ListGroup.Item>
                <ListGroup.Item style={{ textAlign: "center" }}>
                  <button
                    type="button"
                    style={{
                      color: "white",
                      fontSize: "20px",
                      boxShadow: "0px 0px 1px 1px black",
                      backgroundImage: "linear-gradient(147deg, black 90%, white 0%)",
                      padding: "5px 20px 5px 20px",
                      borderRadius: "5px"
                    }}
                    onClick={(e) => handleServiceReqSubmit(e)}
                  >
                    Submit
                  </button>
                </ListGroup.Item>
              </form>
            </ListGroup>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateServiceRequest;
